<template>
  <div>
    <el-dialog :title="$t('merchant.update_merchant_app')" :close-on-click-modal="false" :visible.sync="dialogUserVisible" width="900px" @close="closeModal">
      <el-form ref="form" :model="form" class="form-container" label-width="150px" label-position="left">
        <el-form-item :label="$t('merchant.merchant_name')" prop="app_name" required>
          <el-input :value="merchant.merchant_name" size="small" :placeholder="$t('merchant.merchant_name')" class="search-frame" autocomplete="off" clearable :disabled="isUpdateModal" />
        </el-form-item>
        <el-form-item :label="$t('merchant.notice_webhook')" prop="notice_webhook">
          <el-input v-model="form.notice_webhook" size="small" :placeholder="$t('merchant.notice_webhook')" class="search-frame" autocomplete="off" clearable />
        </el-form-item>

        <el-form-item :label="$t('merchant.callback_event_list')">
          <el-checkbox-group v-model="form.event_names">
            <el-checkbox v-for="(event, index) in eventList" :key="event" :label="event">{{ event + eventIsWithBr(index) }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item :label="$t('merchant.qrcode_webhook')" prop="qrcode_webhook">
          <el-input v-model="form.qrcode_webhook" size="mini" :placeholder="$t('merchant.qrcode_webhook')" class="search-frame" autocomplete="off" clearable />
        </el-form-item>
        <el-form-item :label="$t('merchant.transfer_webhook')" prop="transfer_webhook">
          <el-input v-model="form.transfer_webhook" size="mini" :placeholder="$t('merchant.transfer_webhook')" class="search-frame" autocomplete="off" clearable />
        </el-form-item>

      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogUserVisible = false">{{ $t('components.cancel') }}</el-button>
        <el-button type="primary" :disabled="listLoading" @click="onClickSubmitBtn">{{ $t('components.update') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { addMerchantApp, fetchEventList, updateMerchantAppEvent } from '@/api/merchant-manage/merchant-manage'

export default {
  name: 'MerchantAppModal',
  data() {
    return {
      dialogUserVisible: false,
      listLoading: false,
      eventList: [],
      merchant: {},
      form: {
        app_name: '',
        notice_webhook: '',
        qrcode_webhook: '',
        transfer_webhook: '',
        collect_url: '',
        validate_url: '',
        public_key: '',
        white_ips: '',
        event_names: []
      },
      isUpdateModal: false,
      updateBeforeDate: {} // 更新之前数据
    }
  },
  computed: {
    eventIsWithBr(index) {
      return function() {
        return (index + 1) % 4 ? '<br/>' : ''
      }
    }
  },
  created() {
    this.getEventList()
  },
  mounted() {
    this.$bus.off('SHOW_UPDATE_MERCHANT_APP_MODAL')
    this.$bus.on('SHOW_UPDATE_MERCHANT_APP_MODAL', (value) => {
      this.dialogUserVisible = value[0]
      // 如果有值说明是更新
      if (value[1]) {
        const { merchant = {}, app_name, notice_webhook, qrcode_webhook, transfer_webhook,  collect_url, validate_url, app_events = [] } = value[1]
        // 保存用户已选择的时间名称
        let eventArr = []
        if (Array.isArray(app_events)) {
          eventArr = app_events.map(item => {
            return item.event_name
          })
        }
        //  标志是修改弹框，之后全部用这个区别添加还是修改
        this.isUpdateModal = true
        this.updateBeforeDate = value[1]
        this.merchant = merchant
        // 更新只上传允许更新部分
        this.form = {
          app_name,
          notice_webhook,
          qrcode_webhook,
          transfer_webhook,
          collect_url,
          validate_url,
          event_names: eventArr
        }
      }
    })
  },
  methods: {
    initData() {
      this.form = {
        app_name: '',
        notice_webhook: '',
        qrcode_webhook: '',
        transfer_webhook: '',
        collect_url: '',
        validate_url: '',
        event_names: []
      }
      this.isUpdateModal = true
      this.updateBeforeDate = {} // 更新之前数据
      this.$nextTick(function() {
        this.$refs['form'].clearValidate()
      })
    },
    getEventList() {
      fetchEventList().then(res => {
        if (res.code === 10000) {
          this.eventList = res.data
        }
      })
    },
    closeModal() {
      this.initData()
    },
    updateSubmit() {
      const { notice_webhook,qrcode_webhook, transfer_webhook, event_names = [] } = this.form
      if (!notice_webhook && !qrcode_webhook && !transfer_webhook) {
        this.$message.warning('Merchant callback interfaces cannot be NULL')
        return
      }
      if (notice_webhook && Array.isArray(event_names) && event_names.length <= 0) {
        this.$message.warning('The event list cannot be null')
        return
      }

      this.form.id = this.updateBeforeDate.appkey

      updateMerchantAppEvent(this.form).then(res => {
        if (res.code === 10000) {
          this.$message.success('Update Successfully')
          this.$emit('getMerchantAppList')
          this.dialogUserVisible = false
        }
      })
    },
    onClickSubmitBtn() {
      this.updateSubmit()
    }
  }
}
</script>

<style scoped>
.form-container{
  margin: 0 100px 0
}
</style>
